<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g id="alert-square" transform="translate(0 0)">
            <g id="Component_7_1" data-name="Component 7 – 1" transform="translate(0 0)">
                <path id="Path_307" data-name="Path 307" d="M17.6,1.35H2.6A1.25,1.25,0,0,0,1.35,2.6v15A1.25,1.25,0,0,0,2.6,18.85h15a1.25,1.25,0,0,0,1.25-1.25V2.6A1.25,1.25,0,0,0,17.6,1.35ZM2.6.1A2.5,2.5,0,0,0,.1,2.6v15a2.5,2.5,0,0,0,2.5,2.5h15a2.5,2.5,0,0,0,2.5-2.5V2.6A2.5,2.5,0,0,0,17.6.1Z" transform="translate(-0.1 -0.1)" fill="#231f20" fill-rule="evenodd"/>
                <path id="Path_308" data-name="Path 308" d="M2.95,1.85A1.25,1.25,0,1,0,1.7,3.1,1.25,1.25,0,0,0,2.95,1.85Z" transform="translate(8.302 11.9)" fill="#231f20"/>
                <path id="Path_309" data-name="Path 309" d="M.461,1.55a1.131,1.131,0,1,1,2.25,0L2.273,5.933a.691.691,0,0,1-1.375,0Z" transform="translate(8.414 4.693)" fill="#231f20"/>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "alert-square"
}
</script>

<style scoped>

</style>
